<template>
  <div>
    <Card style="margin-top: 20px; position: relative">
      <el-row type="flex" justify="start" style="margin-bottom: 20px">
        <el-col style="margin-left: 15px; width: 400px">
          <el-date-picker
            v-model="all_time"
            @change="dateChange"
            type="daterange"
            size="small"
            value-format="yyyy-MM-dd"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            placeholder="请选择日期"
            >></el-date-picker
          >
        </el-col>
        <el-col style="padding-left: 15px; width: 400px">
          <el-select v-model="online" clearable placeholder="请选择类型" size="small">
            <el-option
              v-for="item in onlines"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col style="margin-left: 15px">
          <el-button type="primary" size="small" @click="handleSearch()"
            >筛选</el-button
          >
        </el-col>
      </el-row>
      <Table :columns="columns" :data="list">
        <template slot-scope="{ row }" slot="reserve_order_status">
          <div v-if="[1, 2].includes(row.reserve_order_status)">待接单</div>
          <div v-if="[3, 4, 5, 6, 7, -1].includes(row.reserve_order_status)">
            服务中
          </div>
          <div v-if="[8].includes(row.reserve_order_status)">待核销</div>
          <div v-if="[9].includes(row.reserve_order_status)">核销中</div>
          <div v-if="[10].includes(row.reserve_order_status)">已完成</div>
          <div v-if="[11].includes(row.reserve_order_status)">已取消</div>
          <div v-if="[12].includes(row.reserve_order_status)">取消待审核</div>
          <div v-if="[13].includes(row.reserve_order_status)">已预约</div>
        </template>
        <template slot-scope="{ row }" slot="action">
          <div>
            <el-popconfirm
              v-if="[1, 2, 13].includes(row.reserve_order_status)"
              title="确定接单吗？"
              @confirm="doTask(row)"
            >
              <el-button style="margin-right: 10px"  slot="reference" type="text">接单</el-button>
            </el-popconfirm>

            <el-button
              v-if="[12].includes(row.reserve_order_status)"
              type="text"
              style="margin-right: 10px"
              @click="refuseTask(row)"
              >处理取消申请</el-button
            >
            <el-button
              type="text"
              style="margin-right: 10px"
              @click="moveToDetail(row)"
              >详情</el-button
            >
          </div>
        </template>
      </Table>
    </Card>
    <div style="margin-top: 16px; text-align: right">
      <Page
        :total="total"
        :current="page"
        :page-size="size"
        :page-size-opts="sizes"
        :show-total="true"
        :show-elevator="true"
        :show-sizer="true"
        @on-change="onCurrentChange"
        @on-page-size-change="onSizeChange"
      />
    </div>
    <Modal
      v-model="show"
      :mask-closable="false"
      width="550"
      @on-cancel="cancel"
    >
      <div slot="header" style="text-align: center">
        <span>处理取消申请</span>
      </div>
      <Form
        ref="form"
        :model="cur"
        :label-width="150"
        :rules="rule"
         label-position="right"
        style="margin-left: -40px;margin-right: 40px"
      >
        <FormItem label="是否同意" prop="flag">
          <RadioGroup v-model="cur.flag">
            <Radio :label="'1'">同意</Radio>
            <Radio :label="'0'">拒绝</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="理由" prop="cause" class="causeForm" >
          <Input
            v-model.trim="cur.cause"
            :maxlength="30"
            placeholder="请填写理由"
          ></Input>
        </FormItem>
      </Form>
      <div slot="footer" style="text-align: center">
        <el-button type="info" shape @click="cancel">取消</el-button>
        <el-button type="primary" shape :loading="modalLoading" @click="save"
          >保存</el-button
        >
      </div>
    </Modal>
  </div>
</template>

<script>
import route from "../../route/config";
import {
  getOrderList,
  getOrderTaskDo,
  getOrderTaskCancel,
} from "../../api/packageOrder";
export default {
  data() {
    return {
      list: [],
      columns: [
        {
          title: "工单编号",
          key: "show_reserve_order_no",
          align: "center",
        },
        {
          title: "服务项目",
          key: "sku_name",
          align: "center",
        },
        {
          title: "预约时间",
          key: "create_time",
          align: "center",
        },
        {
          title: "患者姓名",
          key: "patient_name",
          align: "center",
        },
        {
          title: "工单状态",
          key: "reserve_order_status",
          align: "center",
          slot: "reserve_order_status",
        },
        {
          title: "操作",
          key: "action",
          align: "center",
          slot: "action",
        },
      ],
      online: "",
      onlines: [
        {
          value: 0,
          label: "线下",
        },
        {
          value: 1,
          label: "线上",
        },
      ],
      total: 0,
      page: 1,
      size: 10,
      sizes: [10, 20, 30, 40, 50],
      all_time: [],
      begin_date: '',
      end_date: '',
      cur: {},
      rule: {
        flag: [
          {
            required: true,
            message: "请选择是否同意",
            trigger: "blur",
          },
          {
            required: true,
            message: "请选择是否同意",
            trigger: "change",
          },
        ],
        cause: [],
      },
      show: false,
      modalLoading: false,
      re_order_no: "",
    };
  },
  mounted() {},
  created() {
    this.getList();
    console.log(this.$store.state.shift.team_id);
  },
  methods: {
    //   获取接单列表
    getList() {
      // this.begin_date = this.all_time[0]
      // this.end_date = this.all_time[1]
      let params = {
        status: '' ,
        begin_date: this.begin_date ,
        end_date: this.end_date ,
        is_online: this.online,
        address_area_name: "",
        page: this.page,
        size: this.size,
        team_id: this.$store.state.shift.team_id,
      };
      getOrderList(params).then((res) => {
        if (res.code == 0) {
          this.list = res.data;
          this.total = res["x-total-count"];
        } else {
          this.$Message.error(res.message);
        }
      });
    },
     dateChange() {
      if (this.all_time) {
        this.begin_date = this.all_time[0]
        this.end_date = this.all_time[1]
      } else {
        this.begin_date = ''
        this.end_date = ''
      }
    },
    // 接单
    doTask(i) {
      let params = {
        reserve_order_no: i.reserve_order_no,
        do_flag: 0,
        team_id: this.$store.state.shift.team_id,
      };
      getOrderTaskDo(params).then((res) => {
        if (res.code == 0) {
          this.$Message.success("接单成功");
          this.getList();
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    // 拒单
    refuseTask(i) {
      this.show = true;
      this.re_order_no = i.reserve_order_no;
    },
    //
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (!this.cur.cause && this.cur.flag == 0) {
            this.$Message.warning("请填写拒绝理由");
            return;
          }
          this.modalLoading = true;
          const params = {
            order_no: this.re_order_no,
            flag: parseInt(this.cur.flag),
            cause: this.cur.cause,
          };
          getOrderTaskCancel(params).then((res) => {
            this.modalLoading = false;
            if (res.code === 0) {
              this.$Message.success("成功");
              this.cancel();
              this.getList();
            } else {
              this.$Message.error(res.message);
            }
          });
        }
      });
    },
    //
    cancel() {
      this.$refs.form.resetFields();
      this.show = false;
      this.modalLoading = false;
    },
    // 筛选
    handleSearch() {
      this.page = 1;
      this.getList();
    },
    // 列表分页
    onCurrentChange(current) {
      this.page = current;
      this.getList();
    },
    onSizeChange(size) {
      this.size = size;
      this.getList();
    },
    // 跳转详情
    moveToDetail(row) {
      this.$store.commit("setAllSelectedKeys", {
        type: "add",
        name: "packageDetail",
        title: route["packageDetail"].title,
        key: "packageDetail",
        extra: {
          id: row.reserve_order_no,
        },
      });
    },
  },
};
</script>

<style >
.causeForm > .ivu-form-item-label {
  margin-left: -24px;
}
</style>
